import type { AnchorHTMLAttributes, ReactNode } from "react";
import { Link } from "react-router-dom";

/**
 * Component overrides for MDX guides.
 *
 * Typography lives in the `.gt-prose` CSS layer so guide content and the
 * spec-derived descriptions render identically. Only behaviour that CSS cannot
 * express is handled here.
 */
export const mdxComponents = {
  a: ({ href, children, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement>) => {
    // Internal links stay client-side; external ones get the usual safety attrs.
    if (href?.startsWith("/")) {
      return (
        <Link to={href} {...rest}>
          {children}
        </Link>
      );
    }
    return (
      <a href={href} target="_blank" rel="noreferrer noopener" {...rest}>
        {children}
      </a>
    );
  },

  /** Callout used by guides: <Note>…</Note> / <Note tone="warning">…</Note> */
  Note: ({
    children,
    tone = "info",
  }: {
    children: ReactNode;
    tone?: "info" | "warning" | "danger";
  }) => {
    const tones = {
      info: "border-info/30 bg-info-tint text-info",
      warning: "border-warning/30 bg-warning-tint text-warning",
      danger: "border-danger/30 bg-danger-tint text-danger",
    } as const;

    return (
      <div
        className={`gt-note rounded-default border px-3.5 py-2.5 ${tones[tone]}`}
      >
        {children}
      </div>
    );
  },
};
